interface Props { active?: boolean }
export function BodyIcon({ active }: Props) {
  const sw = active ? 2.4 : 1.7;
  return (
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none">
      <circle cx={13} cy={6} r={2.6} stroke="currentColor" strokeWidth={sw} />
      <path
        d="M7 22l2-8h8l2 8M9 14l-1-4 5-1 5 1-1 4"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
